import React from "react";
import { Link } from "react-router-dom";
import "./WhatToExpect.css";

function WhatToExpect() {
  return (
    <div className="wte-container">
      {/* Main Title */}
      <h1 className="wte-main-title">What to Expect</h1>

      {/* Card: Journey + Treatment Options */}
      <section className="wte-card">
        <h2>Your Journey to Recovery</h2>
        <p>
          We’re committed to guiding you through each step of your physiotherapy
          journey. Whether you’re seeking relief from acute pain or working toward
          long-term mobility, our tailored treatment approach can help you achieve
          your goals.
        </p>
      </section>

      <section className="wte-card alt-bg">
        <h2>Treatment Options</h2>
        <p>
          We offer a variety of therapies, including manual therapy, therapeutic
          exercises - like stretching,strengthening,isometric exercise, electrotherapy, and more—all designed to speed up your recovery
          and prevent future injuries.
        </p>
      </section>

      {/* Two-Column Layout: Clinic vs Home Visits */}
      <section className="wte-two-column">
        <div className="wte-card left-col">
          <h3>Clinic Sessions</h3>
          <p>
            Our fully-equipped clinic provides the optimal environment for your
            physiotherapy journey. Here you’ll have access to specialized equipment
            and a professional setting designed for maximum therapeutic benefit.
          </p>
        </div>

        <div className="wte-card alt-bg right-col">
          <h3>Home Visits</h3>
          <p>
            We understand that some patients may have mobility challenges or specific
            circumstances that make clinic visits difficult. Our physiotherapists are
            available for home visits, bringing their expertise directly to you. While
            we recommend clinic sessions for access to specialized equipment, we
            ensure the same high standard of care during home visits.
          </p>
        </div>
      </section>

      {/* Card: Your First Visit */}
      <section className="wte-card">
        <h3>Your First Visit</h3>
        <p>
          Whether at our clinic or your home, your initial consultation (30-45 minutes)
          will include:
        </p>
        <ul className="wte-list">
          <li>Comprehensive medical history review</li>
          <li>Detailed physical examination</li>
          <li>Assessment of your current condition</li>
          <li>Discussion of your treatment goals</li>
          <li>Development of a personalized treatment plan</li>
          <li>Initial treatment if time permits</li>
        </ul>
      </section>

      {/* Highlighted Box: What to Bring */}
      <section className="wte-highlight-box">
        <h3>What to Bring</h3>
        <ul className="wte-list">
          <li>Medical reports and relevant imaging (X-rays, MRI scans)</li>
          <li>List of current medications</li>
          <li>Comfortable clothing suitable for movement</li>
          <li>Any mobility aids you currently use</li>
        </ul>
      </section>

      {/* Card: Treatment Sessions */}
      <section className="wte-card alt-bg">
        <h3>Treatment Sessions</h3>
        <p>Each session typically lasts 45-60 minutes and includes:</p>
        <ul className="wte-list">
          <li>One-on-one attention from your dedicated physiotherapist</li>
          <li>Combination of manual therapy and therapeutic exercises</li>
          <li>Regular progress assessment</li>
          <li>Home exercise program instructions and updates</li>
          <li>Treatment plan modifications based on your progress</li>
        </ul>
      </section>

      {/* Card: Guidelines for Better Outcomes */}
      <section className="wte-card">
        <h3>Guidelines for Better Outcomes</h3>
        <div className="wte-two-column-content">
          <div>
            <h4>For Clinic Visits</h4>
            <ul className="wte-list">
              <li>Arrive 10-15 minutes early for your first appointment</li>
              <li>Wear loose, comfortable clothing</li>
              <li>Easy access to treatment area for maximum benefit</li>
              <li>Free parking available at the clinic</li>
            </ul>
          </div>
          <div>
            <h4>For Home Visits</h4>
            <ul className="wte-list">
              <li>Ensure a clear space for exercises</li>
              <li>Have a firm bed or sturdy chair available</li>
              <li>Keep pets secured in another room during treatment</li>
              <li>Provide accurate address and contact information</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Card: Communication & Progress */}
      <section className="wte-card alt-bg">
        <h3>Communication and Progress</h3>
        <p>
          We believe in keeping you informed throughout your recovery journey:
        </p>
        <ul className="wte-list">
          <li>Regular progress assessments</li>
          <li>Clear communication about treatment goals and timeline</li>
          <li>Updates to your referring physician</li>
          <li>Ongoing support and guidance</li>
          <li>Adjustments to your treatment plan as needed</li>
        </ul>
        <p>
          Remember to inform your therapist about any changes in your condition,
          follow your prescribed home exercise program, and ask questions if you’re
          unsure about any aspect of treatment. Please give at least 24 hours notice
          for appointment changes.
        </p>
      </section>

      {/* CTA at the bottom */}
      <div className="wte-cta">
        <Link to="/contact" className="wte-cta-btn">
          Have More Questions? Contact Us!
        </Link>
      </div>
    </div>
  );
}

export default WhatToExpect;
